module.exports = " <div class=\"col-xs-12 col-md-6 map-container\">\r\n     <div class=\"map\">\r\n         <div id=\"map\"></div>\r\n     </div>\r\n </div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/mapa/mapa.component.html
// module id = ./src/app/mapa/mapa.component.html
// module chunks = main